import clsx from "clsx";
import styles from "./Button.module.scss";
import "../../../styles/_themes.scss";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "wood";
}

const Button = ({
  children,
  variant = "wood",
  className,
  ...props
}: ButtonProps) => {
  return (
    <button
      className={clsx(styles.button, variant === "wood" && "wood-theme", className)}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
